import http from '../plugins/axios'

export const getListCountry = async (params) => {
  try {
    const response = await http.get(`/countries`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}